import { Mic, Check, X } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { useVocals, useUpdateVocal } from "@/hooks/useAdminData";
import { Skeleton } from "@/components/ui/skeleton";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export default function Vocals() {
  const { data: vocals, isLoading } = useVocals();
  const updateVocal = useUpdateVocal();

  const handleToggle = async (id: string, isActive: boolean) => {
    try {
      await updateVocal.mutateAsync({ id, is_active: isActive });
      toast.success(isActive ? "Вокал активирован" : "Вокал деактивирован");
    } catch (error) {
      toast.error("Ошибка при обновлении");
    }
  };

  return (
    <AdminLayout title="Вокалы" description="Управление типами вокала">
      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Mic className="w-5 h-5 text-primary" />
            Список вокалов
          </CardTitle>
          <CardDescription>Включите или выключите типы вокала для пользователей</CardDescription>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="space-y-4">
              {[1, 2].map((i) => (
                <Skeleton key={i} className="h-16 w-full" />
              ))}
            </div>
          ) : (
            <div className="space-y-3">
              {vocals?.map((vocal) => (
                <div key={vocal.id} className="flex items-center justify-between p-4 rounded-lg bg-muted/50 border border-border/50">
                  <div className="flex items-center gap-4">
                    <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-xl">
                      {vocal.emoji}
                    </div>
                    <div>
                      <p className="font-medium">{vocal.name}</p>
                      <p className="text-xs text-muted-foreground">
                        Suno стиль: {vocal.suno_style || '—'}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    {vocal.is_active ? (
                      <span className="text-xs text-primary flex items-center gap-1">
                        <Check className="w-3 h-3" /> Активно
                      </span>
                    ) : (
                      <span className="text-xs text-muted-foreground flex items-center gap-1">
                        <X className="w-3 h-3" /> Неактивно
                      </span>
                    )}
                    <Switch
                      checked={vocal.is_active}
                      onCheckedChange={(checked) => handleToggle(vocal.id, checked)}
                    />
                  </div>
                </div>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </AdminLayout>
  );
}
